import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { POST_PDF, CLEAR_RESULTS } from './constants';

const initialState = {
  data: {
    isSuccess: false,
  },
};

export const uploadReducer = createReducer(initialState, {
  [`${POST_PDF}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      data: { ...action.payload, isSuccess: true },
    };
  },

  [CLEAR_RESULTS]: () => {
    return {
      data: { isSuccess: false },
    };
  },
});
